import styled from 'styled-components'
import { Card as CardComp } from 'src/components/Ant'

const Card = styled(CardComp)`
  margin-bottom: 16px;
`
export { Card }
